module.exports = __webpack_public_path__ + "static/media/tree_2.8e91656f.jpg";